var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.903 3.014a.907.907 0 0 0-.612.41.889.889 0 0 0 .193 1.17 7.179 7.179 0 0 1 0 11.248.891.891 0 0 0-.193 1.173.902.902 0 0 0 1.322.228A8.967 8.967 0 0 0 19 10.219a8.968 8.968 0 0 0-3.387-7.024.887.887 0 0 0-.71-.181zm-9.806.001a.887.887 0 0 0-.71.18A8.968 8.968 0 0 0 1 10.219a8.968 8.968 0 0 0 3.387 7.024.902.902 0 0 0 1.322-.228.889.889 0 0 0-.193-1.171 7.179 7.179 0 0 1 0-11.248.89.89 0 0 0 .191-1.173.902.902 0 0 0-.61-.408zm1.916 3.062a.84.84 0 0 0-.713.217 5.374 5.374 0 0 0-1.7 3.925c0 1.549.655 2.941 1.7 3.925.4.376 1.055.264 1.348-.2l.004-.006c.234-.371.15-.844-.166-1.151A3.57 3.57 0 0 1 6.4 10.219 3.57 3.57 0 0 1 7.486 7.65c.315-.307.4-.78.166-1.152l-.004-.005a.922.922 0 0 0-.635-.417zm5.974.002a.92.92 0 0 0-.635.415l-.004.005c-.234.372-.15.845.166 1.152a3.57 3.57 0 0 1 1.086 2.568 3.567 3.567 0 0 1-1.088 2.568c-.315.307-.398.779-.164 1.151l.004.006c.293.464.949.577 1.348.2a5.37 5.37 0 0 0 1.7-3.925 5.374 5.374 0 0 0-1.7-3.925.84.84 0 0 0-.713-.215zM10 8.42a1.8 1.8 0 1 0 0 3.6 1.8 1.8 0 0 0 0-3.6z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublished);
export default __webpack_public_path__ + "static/media/published.e99c10aff422ff76d0d954fb7f71b282.svg";
export { ForwardRef as ReactComponent };